'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_LeftMenu$PlanInfo(code, name, desc) {
  this.Ki = null;
  this.Kk = null;
  this.Kj = null;
  this.Ki = code;
  this.Kk = name;
  this.Kj = desc;
}
export { $c_Lpresto_LeftMenu$PlanInfo as $c_Lpresto_LeftMenu$PlanInfo };
$p = $c_Lpresto_LeftMenu$PlanInfo.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LeftMenu$PlanInfo;
/** @constructor */
function $h_Lpresto_LeftMenu$PlanInfo() {
}
export { $h_Lpresto_LeftMenu$PlanInfo as $h_Lpresto_LeftMenu$PlanInfo };
$h_Lpresto_LeftMenu$PlanInfo.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_LeftMenu$PlanInfo) && (((this.Ki === x$0.Ki) && (this.Kk === x$0.Kk)) && (this.Kj === x$0.Kj))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "PlanInfo";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.Ki;
      break;
    }
    case 1: {
      return this.Kk;
      break;
    }
    case 2: {
      return this.Kj;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_LeftMenu$PlanInfo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iE)));
}
export { $isArrayOf_Lpresto_LeftMenu$PlanInfo as $isArrayOf_Lpresto_LeftMenu$PlanInfo };
var $d_Lpresto_LeftMenu$PlanInfo = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LeftMenu$PlanInfo, "presto.LeftMenu$PlanInfo", ({
  iE: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_LeftMenu$PlanInfo as $d_Lpresto_LeftMenu$PlanInfo };
//# sourceMappingURL=presto.-Left-Menu$-Plan-Info.js.map
